<template>
  <div class="row">
    <div class="span8 detail-main">
      <el-page-header @back="$router.back()" content="详情页面" style="margin-bottom: 18px;"></el-page-header>
      <div style="display: flex;">
        <div style="width: 45%;">
          <img :src="content.oldstuff_img" style="width: 100%; border-radius: 4px;" />
        </div>
        <div style="width: 50%; margin-left: 5%;">
          <h3 style="font-size: 22px; margin-bottom: 12px;">{{ content.oldstuff_name }}</h3>
          <div style="background: #fff7f7; border: 1px solid #ffe1e1; border-radius: 4px; padding: 14px 16px; margin-bottom: 14px;">
            <span style="font-size: 13px; color: #666;">现价：</span>
            <span style="color: #e60000; font-size: 24px; font-weight: bold;">￥{{ content.oldstuff_price }}</span>
            <span style="font-size: 13px; color: #999; margin-left: 14px;">原价：￥{{ content.oldstuff_price }}</span>
          </div>
          <p style="color: #999; font-size: 13px; margin-bottom: 12px;">卖家信息———————————————</p>
          <div class="info-unit"><span class="tagname">卖 家</span><author-pop :author="content"></author-pop></div>
          <div class="info-unit"><span class="tagname">卖家 QQ</span>{{ content.qq }}</div>
          <div class="info-unit"><span class="tagname">联系电话</span>{{ content.phone }}</div>
          <el-button type="primary" style="margin-top: 12px;" @click="dialogVisible = true">有意向购买</el-button>
        </div>
      </div>
      <h3 style="font-size: 18px; margin: 28px 0 12px;">商品描述</h3>
      <blockquote class="post-body" v-html="content.oldstuff_content" style="margin: 0;"></blockquote>
      <div style="margin: 24px 0; text-align: center;">
        <el-button round disabled>👍 66</el-button>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <oldstuffhot-widget />
    </div>
    <div class="span8">
      <comment-widget />
    </div>

    <!-- 购买意向弹窗 -->
    <el-dialog title="欲购买信息" :visible.sync="dialogVisible" width="30%">
      <el-form label-width="100px">
        <el-form-item label="联系方式">
          <el-input v-model="data.describe" placeholder="请输入手机号/QQ"></el-input>
        </el-form-item>
        <el-form-item label="欲购买价格">
          <el-input v-model="data.name" placeholder="请输入你的报价"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setjoin">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import carouselWidget from '@/components/carousel.vue'
import oldstuffhotWidget from '@/components/oldstuffhot.vue'
import commentWidget from '@/components/comment.vue'
import authorPop from '@/components/authorpop.vue'
import { getOldstuffContent, setJoin } from '@/api'

export default {
  name: 'OldstuffContent',
  components: { carouselWidget, oldstuffhotWidget, commentWidget, authorPop },
  props: { id: { type: String, default: '' } },
  data() {
    return {
      content: {},
      dialogVisible: false,
      data: { name: '', describe: '' }
    }
  },
  computed: {
    ...mapState({ commentnum: (s) => s.commentnum })
  },
  watch: {
    id: { immediate: true, handler() { this.getcontent() } }
  },
  methods: {
    getcontent() {
      if (!this.id) return
      getOldstuffContent(this.id).then((res) => {
        this.content = res.data || {}
        this.$store.dispatch('setcontentid', this.id)
        this.$store.dispatch('setcontentinfo', { name: this.content.oldstuff_name, userid: this.content.user_id })
      })
    },
    setjoin() {
      if (!localStorage.luffy_jwt_token) {
        this.$store.dispatch('user/close', true)
        return
      }
      if (!this.data.describe || !this.data.name) {
        this.$message.error('请填写完整信息')
        return
      }
      setJoin({ type: this.$route.name, name: this.data.name, describe: this.data.describe, content_id: this.id, contentname: this.content.oldstuff_name, to_userid: this.content.user_id }).then((res) => {
        if (res.state.type === 'SUCCESS') {
          this.$message.success('添加意向成功')
          this.dialogVisible = false
        } else {
          this.$message.error(res.state.msg || '你已经添加了意向')
        }
      })
    }
  }
}
</script>
